import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import SingleDayPicker from '@React_UI_Lib/SingleDayPicker';
import { M as Modal } from '../../Modal-Df9YL6rb.js';
import '../../style-inject.es-tgCJW-Cu.js';

const GENERIC_ERROR_TEXT = 'Oops! Something wrong here';
const fieldNotEmpty = (val) => {
    return { hasError: !val, errorText: 'Field cannot be empty' };
};
const dateNotInPast = (dateString) => {
    const date = new Date(dateString);
    const currentDate = new Date();
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    return {
        hasError: date <= yesterday,
        errorText: 'Date cannot be in the past'
    };
};
const isValidMobileNumber = (val) => {
    const regexStr = new RegExp('^[0-9]{10}$');
    return {
        hasError: !regexStr.test(val),
        errorText: 'Invalid! enter 10 digit mobile no.'
    };
};
const DAY_DURATION = 24 * 60 * 60 * 1000;
const formatDate = (date) => {
    return (date.getFullYear() +
        '-' +
        (date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) +
        '-' +
        (date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()));
};
const FormFields = {
    FULL_NAME: 'fullName',
    MOBILE_NUMBER: 'mobileNumber',
    FROM: 'from',
    TO: 'to',
    PICKUP_DATE: 'pickUpDate',
    SPECIAL_REQUEST: 'specialRequest'
};
const FieldConfig = {
    [FormFields.FULL_NAME]: {
        key: FormFields.FULL_NAME,
        defaultValue: '',
        type: 'text',
        label: 'Full Name',
        validators: []
    },
    [FormFields.MOBILE_NUMBER]: {
        key: FormFields.MOBILE_NUMBER,
        defaultValue: '',
        type: 'mobileText',
        label: 'Mobile No.',
        validators: [fieldNotEmpty, isValidMobileNumber]
    },
    [FormFields.FROM]: {
        key: FormFields.FROM,
        defaultValue: '',
        type: 'text',
        label: 'From',
        validators: [fieldNotEmpty]
    },
    [FormFields.TO]: {
        key: FormFields.TO,
        defaultValue: '',
        type: 'text',
        label: 'To',
        validators: []
    },
    [FormFields.PICKUP_DATE]: {
        key: FormFields.PICKUP_DATE,
        defaultValue: formatDate(new Date(new Date().getTime() + DAY_DURATION)),
        type: 'date',
        label: 'Pick-up Date',
        validators: [dateNotInPast]
    },
    [FormFields.SPECIAL_REQUEST]: {
        key: FormFields.SPECIAL_REQUEST,
        defaultValue: '',
        type: 'textarea',
        label: 'Any Special Request (Optional)'
    }
};
const detectUserActivity = () => {
    localStorage.removeItem('userActionDone');
    ['click'].forEach(evt => document.body.addEventListener(evt, () => {
        if (window === null || window === void 0 ? void 0 : window.localStorage) {
            localStorage.setItem('userActionDone', 'true');
        }
    }));
};

const InputField = ({ fieldConfig, formData, onChangeHandler, customClassName, onFocusHandler, onClickHandler }) => {
    const { type, key, label } = fieldConfig;
    const { val: inputValue, hasError, errorText } = formData === null || formData === void 0 ? void 0 : formData[key];
    const mobileInputRef = useRef(null);
    return (() => {
        switch (type) {
            case 'date': {
                return (jsxs("div", { className: `floatingInputContainer ${hasError ? 'formErrorText' : ''}`, children: [jsxs("div", { className: "floatingStyledInput wide", children: [jsx("input", { className: customClassName, type: "text", readOnly: true, value: inputValue }), label && (jsx("label", { className: `${inputValue !== '' ? 'stickTop stickTopDate' : ''}`, children: label }))] }), hasError && jsx("p", { className: "formErrorText", children: errorText })] }));
            }
            case 'textarea': {
                return (jsxs("div", { className: `floatingInputContainer ${hasError ? 'formErrorText' : ''}`, children: [jsxs("div", { className: "floatingStyledInput wider", children: [jsx("textarea", { className: customClassName, onChange: e => onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(e.target.value, key), wrap: "hard", rows: 2, children: inputValue }), jsx("label", { className: `${inputValue !== '' ? 'stickTop' : ''}`, children: label }), jsx("span", {})] }), hasError && jsx("p", { className: "formErrorText", children: errorText })] }));
            }
            case 'mobileText': {
                return (jsxs("div", { className: `floatingInputContainer mobileInput ${hasError ? 'formErrorText' : ''}`, children: [jsxs("div", { className: "inputContainer number", children: [jsx("label", { children: label }), jsxs("div", { className: customClassName, children: [jsx("input", { maxLength: 4, className: "countryInput", value: '+91' }), jsx("span", { className: "latoBold", children: " - " }), jsx("input", { ref: mobileInputRef, inputMode: "numeric", className: `${customClassName} leftPadding10`, value: inputValue, onChange: e => onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(e.target.value, key), onClick: e => onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler(), maxLength: 10 })] })] }), hasError && jsx("p", { className: "formErrorText", children: errorText })] }));
            }
            default: {
                return (jsxs("div", { className: `floatingInputContainer ${hasError ? 'formErrorText' : ''}`, children: [jsxs("div", { className: "floatingStyledInput", children: [jsx("input", { className: customClassName, type: "text", value: inputValue, onChange: e => onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler(e.target.value, key), onFocus: e => onFocusHandler === null || onFocusHandler === void 0 ? void 0 : onFocusHandler() }), label && (jsx("label", { className: `${inputValue !== '' ? 'stickTop' : ''}`, children: label })), jsx("span", {})] }), hasError && jsx("p", { className: "formErrorText", children: errorText })] }));
            }
        }
    })();
};

const InboundCallBoxInAsstForm = ({ inboundCallText, inboundCallNumber }) => {
    return (jsxs("div", { className: "inboundCallInfoForm", children: [jsx("div", { className: "inboundCallTextForm", children: inboundCallText }), jsx("div", { className: "inboundCallNumberAreaForm", children: jsx("span", { className: "inboundCallNumberTextForm", children: inboundCallNumber }) })] }));
};

const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';
const FORM_DATA_STORAG_TTL = 24 * 60 * 60 * 1000;
const InputForm = ({ onFormClose, onFormSubmit, formData, setFormFields, formSubmit, setFormSubmit, children, trackEvent, formApiError, setFormApiError, pageName }) => {
    const [showDateModal, setShowDateModal] = useState(false);
    const [isLoadingAPI, setIsLoadingAPI] = useState(false);
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
            setAssistedFromInfoWithExpiry();
            setFormSubmit({
                formSubmit: false,
                formApiError: false,
            });
        };
    }, []);
    useEffect(() => {
        if (formApiError) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Submit_Error`);
            setIsLoadingAPI(false);
        }
    }, [formApiError]);
    const setAssistedFromInfoWithExpiry = () => {
        try {
            (window === null || window === void 0 ? void 0 : window.localStorage) &&
                localStorage.setItem(ASSISTED_FORM_DATA_LS, JSON.stringify(Object.assign(Object.assign({}, formData), { expiry: new Date().getTime() + FORM_DATA_STORAG_TTL })));
        }
        catch (err) {
            console.error(err);
        }
    };
    const onModalClose = () => {
        setTimeout(() => {
            setShowDateModal(false);
        }, 10);
    };
    const onInputFieldChanged = (val, key, callbackFn) => {
        var _a;
        const validators = (_a = FieldConfig === null || FieldConfig === void 0 ? void 0 : FieldConfig[key]) === null || _a === void 0 ? void 0 : _a.validators;
        let fieldHasError = false, fieldErrorText = '';
        for (let i = 0; i < (validators || []).length; i++) {
            const { hasError, errorText = '' } = (validators === null || validators === void 0 ? void 0 : validators[i](val)) || {};
            if (hasError) {
                fieldHasError = hasError;
                fieldErrorText = errorText;
                break;
            }
        }
        setFormFields((prevData) => (Object.assign(Object.assign({}, prevData), { [key]: Object.assign(Object.assign({}, prevData[key]), { val, hasError: fieldHasError, errorText: fieldErrorText }) })));
        callbackFn === null || callbackFn === void 0 ? void 0 : callbackFn();
    };
    const onFormSubmitted = () => {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Submitted`);
        //check errors in the form
        const { formHasErrors, firstFieldWithError } = validateFieldErrors === null || validateFieldErrors === void 0 ? void 0 : validateFieldErrors();
        if (formHasErrors) {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Submitted_Validation_Error_${firstFieldWithError}`);
            return;
        }
        setIsLoadingAPI(true);
        onFormSubmit(formData);
    };
    const validateFieldErrors = () => {
        var _a, _b;
        let formHasErrors = false;
        let firstFieldWithError = '';
        for (const field in formData) {
            const currVal = (_a = formData[field]) === null || _a === void 0 ? void 0 : _a.val;
            const validators = (_b = FieldConfig === null || FieldConfig === void 0 ? void 0 : FieldConfig[field]) === null || _b === void 0 ? void 0 : _b.validators;
            for (let i = 0; i < (validators || []).length; i++) {
                const { hasError, errorText } = validators === null || validators === void 0 ? void 0 : validators[i](currVal);
                setFormFields((prevData) => (Object.assign(Object.assign({}, prevData), { [field]: Object.assign(Object.assign({}, prevData[field]), { hasError,
                        errorText }) })));
                formHasErrors = formHasErrors || hasError;
                if (hasError) {
                    firstFieldWithError = firstFieldWithError
                        ? firstFieldWithError
                        : field;
                    break;
                }
            }
        }
        return { formHasErrors, firstFieldWithError };
    };
    return (jsxs("div", { className: "modalViewOverlay", children: [jsxs("div", { className: "modalViewOuterContainer", children: [jsx("div", { className: "modalViewContainer", children: !formSubmit ? (jsxs("div", { className: "modalWrapper assistedModal", children: [jsx("div", { className: "crossIc", onClick: onFormClose }), jsx("p", { className: "modalTitle", children: "We are here to assist you" }), jsx("p", { className: "modalSubTitle", children: "Just share few details and our agent will reach out" }), jsxs("div", { className: "formContainer", children: [jsxs("div", { className: "formRow mobCol", children: [jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FULL_NAME], onChangeHandler: onInputFieldChanged, onFocusHandler: () => trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Name_Clicked`) }), jsx("div", { className: "inputSeperator" }), jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.MOBILE_NUMBER], customClassName: "numberInput", onChangeHandler: onInputFieldChanged, onClickHandler: () => trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Phone_Clicked`) })] }), jsxs("div", { className: "formRow", children: [jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FROM], onChangeHandler: onInputFieldChanged }), jsx("div", { className: "inputSeperator" }), jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.TO], onChangeHandler: onInputFieldChanged })] }), jsxs("div", { className: "formRow", onClick: () => setShowDateModal(true), children: [jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.PICKUP_DATE] }), jsx(Modal, { show: showDateModal, modalMainCustomClass: "modalMainDatePicker", hideTopSection: true, handleClose: onModalClose, children: jsx(SingleDayPicker, { onDaySelect: (day) => onInputFieldChanged(formatDate(day), FormFields === null || FormFields === void 0 ? void 0 : FormFields.PICKUP_DATE, () => setShowDateModal(false)), disabledPrevDates: true }) })] }), jsx("div", { className: "formRow", children: jsx(InputField, { formData: formData, fieldConfig: FieldConfig[FormFields === null || FormFields === void 0 ? void 0 : FormFields.SPECIAL_REQUEST], onChangeHandler: onInputFieldChanged }) })] }), jsx("div", { className: "formBtnCtaWrap", onClick: onFormSubmitted, children: jsxs("button", { className: `loader-button ${isLoadingAPI ? 'loading' : ''}`, children: [jsx("span", { className: "loader" }), jsx("span", { className: "button-text", children: "SUBMIT" })] }) }), jsxs("div", { className: "form-btm-area", children: [jsxs("div", { className: "seperation-section", children: [jsx("div", { className: "border-seperator" }), jsx("div", { className: "or-text", children: "OR" }), jsx("div", { className: "border-seperator" })] }), jsx(InboundCallBoxInAsstForm, { inboundCallText: "Talk to Agent(24x7)", inboundCallNumber: "0124 - 4781861" })] })] })) : (jsxs("div", { className: "submittedSection", children: [jsx("div", { className: "crossIc", onClick: onFormClose }), formApiError ? (jsxs(Fragment, { children: [jsx("div", { className: "errorIc" }), jsx("p", { className: "submittedTitle", children: GENERIC_ERROR_TEXT }), jsx("span", { className: "reopenFormCTA", onClick: () => {
                                                setFormSubmit(false);
                                                setFormApiError(false);
                                                setIsLoadingAPI(false);
                                            }, children: "TRY AGAIN" })] })) : (jsxs(Fragment, { children: [jsx("div", { className: "greenCheckIc" }), jsx("p", { className: "submittedTitle", children: "We\u2019ve received your details" }), jsx("p", { className: "submittedSubTitle", children: "Our agent will call you shortly" })] }))] })) }), jsx("div", { className: "arrowDownIc" })] }), jsx("div", { className: "modalBackdrop", onClick: onFormClose })] }));
};

const initFormData = {};
for (const key in FieldConfig) {
    const val = FieldConfig[key];
    initFormData[val === null || val === void 0 ? void 0 : val.key] = {
        val: val === null || val === void 0 ? void 0 : val.defaultValue,
        hasError: false
    };
}
const TripAssistantForm = ({ initialFormData, onSubmit, formState, trackEvent, isMobileDevice = false, autoOpenDelay, setFormState, pageName = "Review", showAssistedForm = false, setShowAssistedForm, orgId = "MMT" }) => {
    const [showAssistantIc, setShowAssistantIc] = useState(false);
    const [formData, setFormData] = useState(initFormData);
    const [showModal, setShowModal] = useState(false);
    const userActionDone = () => {
        var _a;
        return ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('userActionDone')) == 'true';
    };
    useEffect(() => {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Trip_Assistant_Shown`);
        window.addEventListener('scroll', listenToScroll);
        detectUserActivity();
        return () => window.removeEventListener("scroll", listenToScroll);
    }, []);
    useEffect(() => {
        if (showAssistedForm) {
            setShowModal(true);
        }
    }, [showAssistedForm]);
    useEffect(() => {
        setTimeout(() => {
            if (!showModal && !userActionDone()) {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Shown_Timeout`);
                setShowModal(true);
            }
        }, autoOpenDelay || 60000);
    }, []);
    useEffect(() => {
        setFormData((prevData) => {
            var _a, _b, _c, _d;
            return (Object.assign(Object.assign({}, prevData), { [FormFields === null || FormFields === void 0 ? void 0 : FormFields.FROM]: Object.assign(Object.assign({}, prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FROM]), { val: (initialFormData === null || initialFormData === void 0 ? void 0 : initialFormData.from) || ((_a = prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FROM]) === null || _a === void 0 ? void 0 : _a.val) }), [FormFields === null || FormFields === void 0 ? void 0 : FormFields.TO]: Object.assign(Object.assign({}, prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.TO]), { val: (initialFormData === null || initialFormData === void 0 ? void 0 : initialFormData.to) || ((_b = prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.TO]) === null || _b === void 0 ? void 0 : _b.val) }), [FormFields === null || FormFields === void 0 ? void 0 : FormFields.MOBILE_NUMBER]: Object.assign(Object.assign({}, prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.MOBILE_NUMBER]), { val: (initialFormData === null || initialFormData === void 0 ? void 0 : initialFormData.phone) || ((_c = prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.MOBILE_NUMBER]) === null || _c === void 0 ? void 0 : _c.val) }), [FormFields === null || FormFields === void 0 ? void 0 : FormFields.FULL_NAME]: Object.assign(Object.assign({}, prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FULL_NAME]), { val: (initialFormData === null || initialFormData === void 0 ? void 0 : initialFormData.name) || ((_d = prevData[FormFields === null || FormFields === void 0 ? void 0 : FormFields.FULL_NAME]) === null || _d === void 0 ? void 0 : _d.val) }) }));
        });
    }, [initialFormData]);
    const listenToScroll = () => {
        const heightToShowFrom = 100;
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll > heightToShowFrom) {
            if (!(isMobileDevice && showModal)) {
                setShowAssistantIc(true);
            }
        }
        else {
            setShowAssistantIc(false);
        }
    };
    const fabInteraction = () => {
        return (jsx("div", { className: isMobileDevice ? "mobileshow" : "desktopShow", children: jsxs("div", { onClick: () => {
                    setShowModal(!showModal);
                    setShowAssistedForm === null || setShowAssistedForm === void 0 ? void 0 : setShowAssistedForm(!showAssistedForm);
                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`${showModal ? `Cab_${pageName}_Assisted_Form_Closed` : `Cab_${pageName}_Assisted_Form_CTA_Click`}`);
                }, className: `fabInteraction ${showModal && isMobileDevice
                    ? 'showCrossIc'
                    : showAssistantIc
                        ? 'showIc'
                        : ''}`, style: { width: !showModal && !showAssistantIc ? orgId === "MMT" ? '160px' : '170px' : undefined }, children: [jsx("div", { className: `icContainer ${showModal && isMobileDevice ? 'showCrossIc' : ''}` }), jsx("span", { children: "Trip Assistant" })] }) }));
    };
    const onFormClose = () => {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(`Cab_${pageName}_Assisted_Form_Closed`);
        setShowModal(false);
        setShowAssistedForm === null || setShowAssistedForm === void 0 ? void 0 : setShowAssistedForm(false);
    };
    return (jsxs("div", { children: [fabInteraction(), showModal && (jsx(InputForm, { onFormClose: onFormClose, onFormSubmit: onSubmit, formData: formData, setFormFields: setFormData, formSubmit: formState.isSubmitted, setFormSubmit: setFormState, trackEvent: trackEvent, formApiError: formState === null || formState === void 0 ? void 0 : formState.hasError, setFormApiError: setFormState, pageName: pageName }))] }));
};

export { TripAssistantForm as default };
